/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FooterAliases {
  AVATAR_CONTATO = 'avatar-contato',
  AVATAR_ENDERECO = 'avatar-endereco',
  FOOTER_0 = 'footer-0',
  IMAGE_FOOTER = 'image-footer',
  LINK_0 = 'link-0',
  LINK_COOKIES = 'link-cookies',
  LINK_VERSION = 'link-version',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  SOCIAL_NETWORKS = 'social-networks',
}
export { FooterAliases };
